<template>
  <!-- 产融大数据 -->
  <div>
    <!-- 顶部背景图 -->
    <div class="homePage-top"></div>
    <!-- 数据灯塔 -->
    <div class="DataDengt">
      <p class="Title">数据灯塔</p>
      <div class="div">
        <div class="div0"></div>
        <div class="div1">
          <div class="div1-1">
            <img src="../../assets/crBigData/sjdt-ffdcgyt.png" alt="" />
            <p>物流大数据</p>
          </div>
          <div class="div1-2">
            <div>
              通过对供应链全程的车、船、箱、货、港、场等环节的智能管控，提高物流效率，提升服务质量，降低物流成本
            </div>
          </div>
        </div>
        <div class="div1">
          <div class="div1-1">
            <img src="../../assets/crBigData/sjdt-gcdsj.png" alt="" />
            <p>工厂大数据</p>
          </div>
          <div class="div1-2">
            <div>
              打通工厂数据孤岛构建大数据平台，实现设备状态监控预警、生产参数优化、大数据实时分析，实现工业互联网数据的价值
            </div>
          </div>
        </div>
        <div class="div1">
          <div class="div1-1">
            <img src="../../assets/crBigData/sjdt-gyldsj.png" alt="" />
            <p>供应链大数据</p>
          </div>
          <div class="div1-2">
            <div>
              构建供应链大数据平台，实现四流全场景的数字化，通过大数据可视化、预测、建模、产融科技等技术，优化各个环节，实现智能决策、降本增效
            </div>
          </div>
        </div>
        <div class="div0"></div>
      </div>
    </div>
    <!-- 数据中台 -->
    <div class="DataZhongt">
      <p class="Title">数据中台</p>
      <p class="min-Title">
        围绕“平台化”、”资产化“、”服务化“，聚焦数智场景，赋能行业生态，让数据产生价值
      </p>
      <div class="div">
        <div class="div0"></div>
        <div class="div1">
          <div class="div1-2">
            <div class="div1-2-1">
              <div>
                核心业务系统
                <ul>
                  <li>CRM</li>
                  <li>智慧风控系统</li>
                  <li>供应链ERP</li>
                  <li>供应链金融系统</li>
                  <li>网络货运平台</li>
                  <li>财务战略管理系统</li>
                  <li>……</li>
                </ul>
              </div>
              <div
                style="border-left: 2px solid #dddddd; border-right: 2px solid #dddddd"
              >
                数据应用
                <ul>
                  <li>运营数据</li>
                  <li>客户数据</li>
                  <li>风控数据</li>
                  <li>业务数据</li>
                  <li>财务数据</li>
                  <li>产品数据</li>
                  <li>……</li>
                </ul>
              </div>
              <div>
                外部数据
                <ul>
                  <li>工商数据</li>
                  <li>税务数据</li>
                  <li>发票数据</li>
                  <li>司法数据</li>
                  <li>社保数据</li>
                  <li>舆情数据</li>
                  <li>……</li>
                </ul>
              </div>
            </div>
            <div class="div1-2-1">
              <div>
                <p>信息化系统</p>
              </div>
              <div>
                <p>数据中台</p>
              </div>
              <div>
                <p>超级API</p>
              </div>
            </div>
          </div>
          <div class="div1-1">
            <img src="../../assets/crBigData/sjzt-tu.png" alt="" />
          </div>
        </div>
        <div class="div0"></div>
      </div>
    </div>
    <!-- 产融大数据全景 -->
    <div class="crDsjQj">
      <p class="Title">产融大数据全景</p>
      <div class="div">
        <div class="div0 div1"></div>
        <div class="div0 div2"></div>
        <div class="div0 div6"></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {};
</script>
<style lang="scss" scoped>
// 顶部背景
.homePage-top {
  background: url("../../assets/crBigData/crBigData-banner.png") center center no-repeat;
  height: 665px;
}
/* 数据灯塔开始 */
.DataDengt {
  color: #333333;
  // background: #ffffff;
  background: #f5f7fa;
}
.DataDengt > .Title {
  font-size: 35px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000000;
  text-align: center;
  padding: 70px 0 30px 0;
}
.DataDengt > .div {
  display: flex;
  padding: 0 5%;
  justify-content: space-between;
}

.DataDengt > .div .div0 {
  flex: 1;
  padding: 0 20px;
}
.DataDengt > .div .div1 {
  padding: 40px 20px;
  width: 248px;
  margin: 0 50px;
}
.DataDengt > .div .div1 .div1-1 {
  text-align: center;
  font-size: 24px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #373d41;
  line-height: 45px;
  margin-bottom: 20px;
}

.DataDengt > .div .div1 .div1-1 img {
  width: 180px;
  height: 158px;
  vertical-align: middle;
  margin-bottom: 16px;
}
.DataDengt > .div .div1 .div1-2 {
  text-align: left;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
  line-height: 29px;
}
/* 数据灯塔结束 */
/* 数据中台开始 */
.DataZhongt {
  color: #333333;
  background: #ffffff;
}
.DataZhongt > .Title {
  font-size: 35px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000000;
  text-align: center;
  padding: 70px 0 20px 0;
}
.DataZhongt > .min-Title {
  font-size: 19px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
  line-height: 35px;
}
.DataZhongt > .div {
  display: flex;
  padding: 0 5%;
  justify-content: space-between;
}

.DataZhongt > .div .div0 {
  flex: 1;
  padding: 0 20px;
}
.DataZhongt > .div .div1 {
  padding: 40px 20px;
  width: 1200px;
  display: flex;
  justify-content: space-between;
  font-family: Microsoft YaHei;
  font-weight: 400;
}
.DataZhongt > .div .div1 .div1-1 {
  width: 40%;
  margin: auto;
  // text-align: center;
  font-size: 24px;
  color: #373d41;
  line-height: 45px;
  margin-bottom: 20px;
}

.DataZhongt > .div .div1 .div1-1 img {
  width: 424px;
  height: 404px;
  margin-left: 50px;
}
.DataZhongt > .div .div1 .div1-2 {
  width: 60%;
  .div1-2-1 {
    width: 100%;
    display: flex;
    font-size: 16px;
    color: #666666;
    line-height: 29px;
    div {
      width: 33%;
      font-size: 24px;
      line-height: 45px;
      padding: 10px 30px;
      p {
        margin-top: 20px;
        display: inline-block;
        background: #f3f8ff;
        padding: 10px 35px;
        font-size: 16px;
        line-height: 29px;
        border-radius: 6px;
      }
      ul {
        margin-top: 30px;
        li {
          font-size: 18px;
          line-height: 30px;
        }
      }
    }
  }
}
/* 数据中台结束 */
/* 产融大数据全景开始 */
.crDsjQj {
  height: 1350px;
  background: #f5f7fa;
}
.crDsjQj > .Title {
  font-size: 35px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000000;
  text-align: center;
  padding: 70px 0 20px 0;
}
.crDsjQj > .div {
  display: flex;
}

.crDsjQj > .div .div1,
.crDsjQj > .div .div6 {
  flex: 1;
  margin: 0 17px;
}
.crDsjQj > .div .div2 {
  margin-top: 50px;
  width: 1206px;
  height: 1092px;
  background: url("../../assets/crBigData/crdsjqj.png") center center no-repeat;
}
/* 产融大数据全景结束 */
</style>
